// extracted by mini-css-extract-plugin
export default {"dom-slide":"styles_dom-slide__d6NCw"};